import { render, staticRenderFns } from "./WaitingForOpponent.vue?vue&type=template&id=6401ea72&"
import script from "./WaitingForOpponent.vue?vue&type=script&lang=js&"
export * from "./WaitingForOpponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports